import { render, staticRenderFns } from "./ChangeFolderIcon.vue?vue&type=template&id=b2d3b508&scoped=true"
import script from "./ChangeFolderIcon.vue?vue&type=script&lang=js"
export * from "./ChangeFolderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d3b508",
  null
  
)

export default component.exports